import React from 'react';
import {observer} from "mobx-react";
import PageComponent from "js/components/pages/PageComponent";
import {makeRequest, navigate, url} from "js/services/Network";
import AppUser from "js/stores/AppUser";
import AnonymousId from "js/services/AnonymousId";
import Backdrop from 'js/components/core/Backdrop';
import ContinueButton, { buttonHeight } from 'js/components/core/SteppedPage/ContinueButton';

import AppContent from "js/components/AppContent"
import Footer from "js/components-v2/common/Footer/Footer";
import {Link} from "@reach/router";
import userCountry from "js/services/UserCountry";
import BuyerVideo from "js/components-v2/pages/BuyerPage/BuyerVideo";
import LovePod from "js/components-v2/pages/BuyerPage/LovePod";
import HowItworks from "js/components-v2/pages/BuyerPage/how/HowItworks";
import BuyerRefHowItWorks from "js/components/pages/BuyerLandingPage/BuyerRefHowItWorks";
import {TestimonialSlider} from "js/new/Components/PageSections";
import {Section} from "js/new/Components";
import {FastestWayToSellOnline} from "js/components/pages/BuyerLandingPage/FastestWayToSellOnline";

@observer
export default class BuyerRefPage extends PageComponent {
  pageName = 'BuyerRefPage';

  constructor(props) {
    super(props);
    this.state = {
      referrer: null,
      defaultRefName: null,
      singleUseToken: '',
    }
  }

  steps = [
    "Sign up with either your socials or your credentials.",
    "Get ₦500 on sign up which can be used at anytime.",
    "Get a referral link and share with your friends to earn ₦3,000 more."
  ]

  redirect = (link, props, params) => navigate(url(link, props, params));

  pageEvent = async () => {
    // if (AppUser.isLoggedIn) {
    //   this.redirect('referral-complete')
    // }

    const url = window.location.href;
    const urlParts = url.split('/');
    const buyer = urlParts[urlParts.length - 1];
    localStorage.setItem('requestedBy', buyer);

    try {
      const response = await makeRequest(
        'buyer-ref-data',
        null,
        {buyer: buyer, anonymous_id: AnonymousId}
      );
      // console.log(response)
      if (response.status === 200) {
        this.setState({defaultRefName: response.data.login})
        this.setState({referrer: response.data})
      }
    } catch (error) {
      this.setState({error: error});
    }

  }

  renderPage() {
    // console.log("defaultRefName: ",this.state.defaultRefName)
    const buttonOffset = buttonHeight / 2;
    const contentOffset = `${buttonOffset}rem`;
    return (
      <AppContent className="buyer-page">
        <div className="pod-hero-container pod-container" style={{backgroundColor:'white'}}>
          <div className="d-md-flex align-items-stretch">
            <div className="hero-section hero-text tw-lg-w-1/2 bg-white md:tw-mt-5" style={{height:'33rem', paddingTop:'1px'}}>
              <div className="d-flex justify-content-start gap-3 mb-3" style={{marginTop:'45px',paddingTop:'15px', paddingBottom:'12px', paddingLeft:'5px', paddingRight:'5px'}}>
                <span className="flex-start">
                      <img
                        src="/images/v2/buyers/trustees.png"
                        alt="Trustees"
                        className="tw-h-[100%] tw-w-full"
                      />
                    </span>
                <span className="my-auto flex-start" style={{font:'Inter', fontWeight: 400, lineHeight:'19.5px', fontSize:'16px'}}>Join 1,000+ sellers using POD</span>
              </div>
              <span style={{fontSize:'35px', lineHeight:'50px',fontWeight:'600'}}>Hi, I'm {this.state.referrer && this.state.referrer.first_name ? this.state.referrer.first_name : this.state.defaultRefName ? this.state.defaultRefName : 'Jeff'}.</span>
              <br/>
              <span style={{fontSize:'30px', lineHeight:'50px',fontWeight:'600'}}>I want to buy your item using PayOnDelivery</span>
              <br/>
              <p className="mt-2 mb-4" style={{fontWeight:400, lineHeight:'27px', fontSize:'16px'}}>POD is the new way to buy and sell online (Your money is guaranteed). Sell to me by loading it here 👇🏽</p>
              <div className="d-flex justify-content-center align-items-center gap-2">
                <button
                  className="tw-w-full tw-mb-1 justify-content-center align-items-center tw-h-[55px] tw-bg-white tw-rounded-lg tw-border-secondary tw-text-secondary"
                  onClick={() => navigate(url('#how-it-works'))} > <a href="#how-it-works" style={{textDecoration:'none'}}>How does it work?</a>
                </button>
                <button
                  className="tw-w-full tw-mb-1 justify-content-center align-items-center tw-h-[55px] tw-bg-secondary tw-rounded-lg tw-border tw-border-white tw-text-white"
                  onClick={() => navigate(url('create-payment-link-page'))} >
                  {'Sell to me'}
                </button>
              </div>
            </div>
            <div className="hero-media d-md-flex align-items-center" style={{padding: '2rem 1.5rem 1.5rem'}}>
              <div className="pod-home-video">
                <div className="tw-hidden md:tw-block tw-w-full tw-h-[100%]">
                  <img
                    src="/images/v2/buyers/buyer-ref-landing1.png"
                    alt="Buyer ref landing"
                    className="tw-h-[518px] tw-w-[660px]"
                  />
                </div>
                <div className="tw-block md:tw-hidden tw-w-full tw-h-[100%]">
                  <img
                    src="/images/v2/buyers/buyer-ref-landing2.png"
                    alt="Buyer ref landing"
                    className="tw-h-[256.65px] tw-w-full"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="how-it-works">
          <BuyerRefHowItWorks />
        </div>


        <Section>
          <TestimonialSlider
            header="Buyers L❤️ve POD"
            slides={[
              {
                image: '/assets/images/shops/Vodatrox.jpeg',
                name: 'Vodatrox LLC',
                position: 'Buyer',
                content: 'I signed up because I buy bulk orders from my vendor and want to be able to secure my payment until after delivery'
              },
              {
                image: '/assets/images/shops/mimi.png',
                name: 'Mimi\'s world',
                position: 'Buyer',
                content: 'Received my order and I appreciate the happy hour incentive that reduced my delivery charge to just 100 Naira. Thanks so much!'
              },
            ]}
          />
        </Section>
        <FastestWayToSellOnline />

        <Footer/>
        <div className="buyer-bottom-button d-md-none d-grid">
          <Link to={'/create-link'} className="btn btn-pod btn-primary">
            {userCountry() !== 'NG' ? 'Start selling faster' : 'Start selling securely'}
          </Link>
        </div>
      </AppContent>
    )
  }
}
